/**
 * test urls
 * @param {*} urls
 * @returns
 */
export const isUrlsOk = (urls) => {
  if (!urls) {
    return false;
  }
  let out = false;
  Object.keys(urls).forEach((el) => {
    if (urls[el]) {
      out = true;
    }
  });
  return out;
};
